import React, { useEffect } from "react";
import "./What_Participant_Say.css";
import { useDispatch, useSelector } from "react-redux";
import { AllComments } from "../../../features/admin/common/Slice";

const formatDateTime = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const optionsDate = { month: "long", day: "numeric", year: "numeric" };
  const optionsTime = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  };

  const formattedDate = date.toLocaleDateString("en-US", optionsDate);
  const formattedTime = date.toLocaleTimeString("en-US", optionsTime);

  return `${formattedDate}, at ${formattedTime}`;
};

const What_Participant_Say = () => {
  const dispatch = useDispatch();
  const comments = useSelector((state) => state?.common?.all_comments || []);

  useEffect(() => {
    dispatch(AllComments());
  }, [dispatch]);

  return (
    <section className="What_Participant_Say">
      <div className="container">
        <h5 className="What_Participant_Say_title">
          What Participants <span>Say</span>
        </h5>

        {comments.length === 0 && (
          <p className="text-muted">No comments available</p>
        )}

        {comments.map((item) => (
          <div className="what_say" key={item.id}>
            <h5 className="what_say_title">
              {item.name} <span>. "{formatDateTime(item.created_at)} "</span>
            </h5>
            <p className="what_say_text">{item.comment}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default What_Participant_Say;
